<template src= "./detail.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import swal from 'sweetalert2'
import { BtnDelete } from '../member/detail.vue'
import agTableComp from '@/optionData/agTableComp'
import axios from 'axios'
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';


export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">{{title}}</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : '선택'
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
  name: 'albumDetail',
  data() {
    return {
      
      ko : ko,
      //
      gridOptions :{ // 테이블 옵션
          onRowClicked: (event)=>{
              
          },
      },
      gridOptions2 :{ // 테이블 옵션
          onRowClicked: (event)=>{
              
          },
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          
          suppressMenu: false,
          rowSelection:'single'
      },
      columnDefs: [
        {headerName: 'E-mail ID', field: 'user.email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let name = `${(data.data.family_name ? data.data.family_name : '')} ${(data.data.given_name ? data.data.given_name : '')}`
            var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
            if(pattern3.test(name)){
                name = `${(data.data.family_name ? data.data.family_name : '')} ${(data.data.given_name ? data.data.given_name : '')}`
            }else{
                name = `${(data.data.given_name ? data.data.given_name : '')} ${(data.data.family_name ? data.data.family_name : '')}` 
            }
                
          return name 
        }},
        {headerName: '회사명', field: 'company', filter: false,width: 150,
          cellRenderer: (data) => {
            
          let company = data.value ? data.value : ''
          return company 
        }},
        {headerName: '사업자구분', field: 'entity', filter: false,width: 150,
            cellRenderer: (data) => {
            let dd ={
                'corporation': '사업자',
                'individual' :'개인'
            }
            let val = data.value ? data.value : ''
            let text = dd[val];
            if(data.value == 'corporation'){
              
              if( data.data.entity_tax_exemption == true){
                  text = dd[val] + ' (면세)'    
              }else{
                  text = dd[val] + ' (비면세)'    
              }
            }
            
            return text
        }},
        {headerName: '정산화폐', field: 'currency', filter: false,width: 100,
          cellRenderer: (data) => {
            
            return data.value.toUpperCase()
        }},
        {headerName: '잔액', field: 'balance', filter: false,width: 150,
          cellRenderer: (data) => {
            
            return  this.numberFormat(data.value) + ' ' + data.data.currency.toUpperCase()
        }},
        {headerName: '거주국가(세율)', field: 'entity_address', filter: false,width: 190,
          cellRenderer: (data) => {
            let text = `
              ${data.value.country} (${data.data.entity_tax_rate}%)
            `
            return text
        }},
        {headerName: '기본정산요율', field: 'currency', filter: false,width: 190,
          cellRenderer: (data) => {
            let t1 = "한국 : "  +data.data.default_service_fee_kr
            let t2 = "해외 : "  +data.data.default_service_fee_other
            
            
            
            return `${t1}% \ ${t2}%`
        }},
        {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `<a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/member/detail/${data.data.user.id}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],
     
      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnSelect : BtnSelect
        }
      },
      columnDefsUser : [
      
        {headerName: 'E-mail ID', field: 'user.email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: '', filter: false,width: 150,
          cellRenderer: (data) => {
            let t = data.value.user.email
            let name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
            var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
            if(pattern3.test(name)){
                name = `${(data.value.family_name ? data.value.family_name : '')} ${(data.value.given_name ? data.value.given_name : '')}`
            }else{
                name = `${(data.value.given_name ? data.value.given_name : '')} ${(data.value.family_name ? data.value.family_name : '')}` 
            }
            return name
        }},
        {headerName: '권리자명 (성 이름)', field: 'company', filter: false,width: 150,
          cellRenderer: (data) => {
            let company = data.value.company ? data.value.company : ''
            return name
        }},
        
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
        
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
            const type = {
                'individual' : '개인',
                'corporation' : '사업자',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
        {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
            let text = ""
            text += "국내 : " + data.value + '%   '
            text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
            return text
        }},
      ],
      keywordType : {label:'권리자명', value:'_name'},
      licensorKeyword : '',
      
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },
      
      selectLicensor : [],
      old_licensor : [],
      new_licensor : [],

      albumGridOptions : {

      },
      albumcolumnDefs: [
        {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
            let dd = {
                temporary :'임시저장',
                registration_complete : '접수', 
                registration_canceled : '유통 취소', 
                inspection_complete : '검수 완료', 
                distribution_complete : '유통 완료', 
                release_complete : '발매 완료', 
                suspended : '유통중단', 
                rejected : '반려',
                trash : '임시삭제'
            }
            let color = {
                temporary : "#9544d0b3",//'임시저장',
                registration_complete : '#262c49',//'접수', 
                registration_canceled : '#797979',//'유통 취소', 
                inspection_complete : '#4092ff',//'검수 완료', 
                distribution_complete : '#ff9f43',//'유통 완료', 
                release_complete : '#24c1a0',//'발매 완료', 
                suspended : '#b8c2cc',//'유통중단', 
                rejected : '#ea5455',//'반려' 
                trash : "#737373"
            }
        return `
        <div class="con-vs-chip vs-chip-primary con-color" 
        style="
            background-color: ${color[data.value]} !important;
            color:#fff;
            line-height:1;
            padding:3px 5px;
            margin:13px 0; 
            font-size:13px;
            min-width:50px;
        ">
            <span style="margin:0" class="text-chip vs-chip--text">
            ${dd[data.value]}
        </span><!----></div>`
        }},
        {headerName: '발매일',      field: 'release_date',     filter: false,width: 140,
        cellRenderer: (data) => {
        return this.fixDate(data.value)
        }},
        {headerName: '자사앨범코드',      field: 'album_ref',     filter: false,width: 150, },
        {headerName: '앨범명',  field: 'name',  filter: false,width: 220},
        {headerName: '앨범아티스트',  field: 'artists',  filter: false,width: 250,cellRenderer: (data) => {
            let t = data.value
            let text =  ''
            for ( var i in t ){
                if(i != 0){
                text += ', '
                }
                text += t[i].display_name
            }
            return text
        }},
        {headerName: '트랙수',      field: 'track_count',     filter: false,width: 80, },
      ],
      albumList : [],
      albumPage: {
          total : 0,
          pageSize : 10,
          currentPage: 1,                       // 현재 페이지
          totalPage: 0,                         // 총 페이지수
      },    


      admin : {
        admin_nickname: "",
        admin_slack_id: "",
        email: "mino@soundrepublica.com"
        
      },
      created_at : null,
      description : null,
    }
  },
  mounted(){
 
   this.$nextTick((vue) =>{
      if(this.$route.params){
        this.datacall();
     
      }
    })
  },
  watch:{
    
    'albumPage.currentPage'(e){
        this.albumCall()
    },
  },
  computed:{
    
  },
  methods: {
    
    datacall(){
      let payload = {
        id : `${this.$route.params.id}`
      }
      this.loadingShow()
      const api1 = new Promise(resolve =>{
        
        this.$store.dispatch('GET_TRANSFER_DETAIL', payload)
        .then(result =>{
            let t = result;
            this.admin = t.user
            this.created_at = t.created_at
            this.selectLicensor =[t.old_licensor] 
            this.description = t.description
            this.old_licensor = [t.old_licensor]
            this.new_licensor = [t.new_licensor] 
            
             resolve(true)
            
        }).catch(error=>{
          const status = error.status
          resolve(false)
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
        })
      })
      const api2 = new Promise(resolve =>{
        payload.params = {
          limit : this.albumPage.pageSize, 
          page : this.albumPage.currentPage - 1
        }
        this.$store.dispatch('GET_TRANSFER_DETAIL_ALBUM', payload)
        .then(result =>{
            let t = result;
            this.albumList = result.items
            //페이지 수
            const remainder = parseInt(result.filtered  % this.albumPage.pageSize) > 0? 1: 0
            this.albumPage.total = result.total
            this.albumPage.totalPage = parseInt(result.filtered/this.albumPage.pageSize) + remainder
            resolve(true)
            
        }).catch(error=>{
          const status = error.status
          resolve(false)
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
        })
      })
      Promise.all([api1,api2])
      .then(result =>{
        this.loadingHide();
      })
      
    },
    albumCall(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          limit : this.albumPage.pageSize, 
          page : this.albumPage.currentPage -1
        }
      }
      this.loadingShow()
      this.$store.dispatch('GET_TRANSFER_DETAIL_ALBUM', payload)
        .then(result =>{
            this.loadingHide()
            let t = result;
            this.albumList = result.items
            //페이지 수
            const remainder = parseInt(result.filtered  % this.albumPage.pageSize) > 0? 1: 0
            this.albumPage.total = result.total
            this.albumPage.totalPage = parseInt(result.filtered/this.albumPage.pageSize) + remainder
            
        }).catch(error=>{
          const status = error.status
          this.loadingHide()
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
    },
    memoUpdate(){
        let payload = {
          id : `${this.$route.params.id}`,
          params : {
            description : this.description 
          }
        }
        this.loadingShow()
        this.$store.dispatch('PUT_TRANSFER_DETAIL_MEMO', payload)
            .then(result =>{
                this.loadingHide()
                let t = result;
                this.description = result.description
            }).catch(error=>{
            const status = error.status
            this.loadingHide()
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                    this.alert({msg:error})
                break;
            }
        })
    }
  }
}
</script>

<style scoped>

</style>
